import { CollectorType, EndPageRedirectType, CollectorIpRestrictionType } from '~lib/generatedGqlTypes';

/** The maximum number of questions which can display on a page */
export const MAX_QUESTIONS_ON_PAGE = 105;

// 10-second expiration window
export const RZ_COOKIE_EXPIRATION = 1 / 8640;

/** The default return values for survey submission */
export const DEFAULT_SUBMIT_RESULT = {
  encryptedCookieValue: '',
  encryptedSmParam: '',
  encryptedSMParamforQuizResults: '',
  success: false,
  userErrors: null,
  surveyPage: null,
  respondent: null,
  encryptedSmSubject: null,
  surveyCompleted: false,
  disqualified: false,
  visibleQuestionIds: null,
};

export const REDIRECT_TYPE: { [key: string]: EndPageRedirectType } = {
  url: 'URL',
  loop: 'LOOP',
  closeWindow: 'CLOSE_WINDOW',
};

export const COLLECTOR_TYPE: { [key: string]: CollectorType } = {
  email: 'EMAIL',
  weblink: 'WEBLINK',
};

export const IP_FILTER_TYPE: { [key: string]: CollectorIpRestrictionType } = {
  allowList: 'ALLOW_LIST',
  blockList: 'BLOCK_LIST',
  unfiltered: 'UNFILTERED',
};
